import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "toast__status" }
const _hoisted_3 = { class: "toast__content" }
const _hoisted_4 = { class: "toast__title" }
const _hoisted_5 = {
  key: 0,
  class: "toast__message"
}
const _hoisted_6 = ["onClick"]

import { computed } from "vue";
import { useStore } from "@/stores";
import IconToastAlert from "@/assets/icons/IconToastAlert.vue";
import IconToastSuccess from "@/assets/icons/IconToastSuccess.vue";
import IconCross from "@/assets/icons/IconCross.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastList',
  setup(__props) {

const store = useStore();
const toasts = computed(() => store.toasts);

const handleClose = (id: string) => {
  store.removeToast(id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: _normalizeClass(["toast", `toast--${toast.type}`])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (toast.type === 'warning')
                ? (_openBlock(), _createBlock(IconToastAlert, { key: 0 }))
                : (_openBlock(), _createBlock(IconToastSuccess, { key: 1 }))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(toast.title), 1),
              (toast.message)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(toast.message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "toast__control",
              onClick: ($event: any) => (handleClose(toast.id))
            }, [
              _createVNode(IconCross)
            ], 8, _hoisted_6)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})